// Funnel bar for the admin dashboard. Extracted verbatim from the
// inline `FunnelBar` function previously inside AdminDashboard.jsx (W2d).
// Same DOM, same test-id, same width math.
export default function FunnelBar({ label, value, max, testid }) {
  const pct = max > 0 ? Math.max(2, Math.round((value / max) * 100)) : 0;
  return (
    <div style={{ marginBottom: 10 }} data-testid={testid}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
        <span className="sf-mono sf-muted-text" style={{ fontSize: 12 }}>{label}</span>
        <span className="sf-mono" style={{ fontSize: 12, color: "var(--sf-gold)" }}>{value}</span>
      </div>
      <div style={{ height: 8, backgroundColor: "#22262B", borderRadius: 4 }}>
        <div style={{ width: `${pct}%`, height: "100%", backgroundColor: "var(--sf-gold-dim)", borderRadius: 4 }} />
      </div>
    </div>
  );
}
